import { render, staticRenderFns } from "./logicSettingsItem2.vue?vue&type=template&id=203c24a4&scoped=true&"
import script from "./logicSettingsItem2.vue?vue&type=script&lang=js&"
export * from "./logicSettingsItem2.vue?vue&type=script&lang=js&"
import style0 from "./logicSettingsItem2.vue?vue&type=style&index=0&id=203c24a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203c24a4",
  null
  
)

export default component.exports